import { createIcon } from '@chakra-ui/react'

export const ReceiveIcon = createIcon({
  displayName: 'ReceiveIcon',
  path: (
    <>
      <path
        d='M9.17018 3.83344L10.8368 3.83344L10.8368 13.8334L15.4202 9.25011L16.6035 10.4334L10.0035 17.0334L3.40351 10.4334L4.58685 9.25011L9.17018 13.8334L9.17018 3.83344Z'
        fill='currentColor'
      />
    </>
  ),
  viewBox: '0 0 21 21',
})
